// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"288":"45b1fc9b","315":"45b1fc9b","935":"45b1fc9b"}[chunkId] + ".chunk.css";
};